<router-outlet></router-outlet>
<!-- Added by Amisha on 2026-06-12. -->
<!-- Reason: host the shared Janus AppView shell-navigation confirmation modal once at the app root. -->
<wm-common-confirmation-modal
  [data]="appViewLeaveConfirmationService.modalData"
  (onYesClick)="appViewLeaveConfirmationService.confirmLeave()"
  (onNoClick)="appViewLeaveConfirmationService.cancelLeave()"
>
</wm-common-confirmation-modal>
<wm-modal-confirm
  #updateVersion
  (accepted)="reloadSite()"
  commandText="Refresh"
  title="Version Update"
  [showButton]="false"
  [showCancelButton]="false"
>
  This site has been updated. Please Refresh to get the latest version.
</wm-modal-confirm>
